(function () {
  function attachCartItemBehavior(cartItem) {
    const itemId = cartItem.getAttribute("data-item-id");

    function changeCartItem(quantity) {
      fetch(window.routes.cartChange, {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({
          id: itemId,
          quantity: quantity,
          sections: "main-cart,navigation-main",
        }),
      })
        .then(function (res) {
          return res.json();
        })
        .then(function (data) {
          const doc = new DOMParser().parseFromString(data.sections["main-cart"], "text/html");

          if (data.item_count === 0) {
            document.querySelectorAll(".cart-items-container, .mini-cart--empty").forEach(function (el) {
              el.outerHTML =
                '<div class="mini-cart--empty">' +
                '<p class="text-lg">Your cart is empty</p>' +
                "<p>There are no items in your cart.</p>" +
                '<a href="/" class="button--sm">Continue shopping</a>' +
                "</div>";
            });

            const recsContainer = document.querySelector(".mini-cart-recommendations");
            if (recsContainer) {
              recsContainer.innerHTML = "";
              recsContainer.classList.add("u-hide");
            }

            [".cart-summary__header", "#cart-total-price", "#checkout", ".cart-summary__free-shipping"].forEach(function (sel) {
              const newEl = doc.querySelector(sel);
              if (!newEl) return;
              document.querySelectorAll(sel).forEach(function (el) {
                el.replaceWith(newEl.cloneNode(true));
              });
            });

            const cartCount = doc.querySelector(".cart-count");
            document.querySelectorAll("#cart-open-block .header__icons--cart-open .cart-count").forEach(function (el) {
              if (cartCount) {
                el.classList.remove("visually-hidden");
                el.textContent = cartCount.textContent;
              } else {
                el.classList.add("visually-hidden");
              }
            });

            return;
          }

          const newItems = doc.querySelector(".cart-items-container, .mini-cart--empty");
          if (newItems) {
            document.querySelectorAll(".cart-items-container, .mini-cart--empty").forEach(function (el) {
              el.replaceWith(newItems.cloneNode(true));
            });
          }
          [".cart-summary__header", "#cart-total-price", "#checkout", ".cart-summary__free-shipping"].forEach(function (sel) {
            const newEl = doc.querySelector(sel);
            if (!newEl) return;
            document.querySelectorAll(sel).forEach(function (el) {
              el.replaceWith(newEl.cloneNode(true));
            });
          });
          document.querySelectorAll(".cart-items-container .icon").forEach(function (icon) {
            icon.classList.add("loaded");
          });
          document.querySelectorAll(".cart-items-container .cart-item").forEach(attachCartItemBehavior);
        })
        .catch(function (err) {
          console.error("Cart change error:", err);
        });
    }

    const removeBtn = cartItem.querySelector(".cart-item-delete, .cart-item__remove");
    if (removeBtn && !removeBtn.dataset.bound) {
      removeBtn.dataset.bound = "true";
      removeBtn.addEventListener("click", function () {
        changeCartItem(0);
      });
    }

    const qtyInput = cartItem.querySelector('input[name="quantity"]');
    const plusBtn = cartItem.querySelector('button[name="plus"]');
    const minusBtn = cartItem.querySelector('button[name="minus"]');
    if (!qtyInput || !plusBtn || !minusBtn || plusBtn.dataset.bound) return;

    let qty = parseInt(qtyInput.value, 10);
    plusBtn.dataset.bound = "true";
    minusBtn.dataset.bound = "true";

    plusBtn.addEventListener("click", function () {
      qty += 1;
      qtyInput.value = qty;
      changeCartItem(qty);
    });
    minusBtn.addEventListener("click", function () {
      qty -= 1;
      qtyInput.value = qty;
      changeCartItem(qty);
    });
  }

  function addToCartFromRecommendation(productId, variantId, button) {
    button.disabled = true;

    const formData = new FormData();
    formData.append("id", variantId);
    formData.append("quantity", 1);
    formData.append("sections", "main-cart");

    fetch(window.routes.cartAdd, {
      method: "POST",
      headers: { Accept: "application/json" },
      body: formData,
    })
      .then(function (res) {
        return res.json();
      })
      .then(function (data) {
        if (data.status) {
          button.disabled = false;
          button.textContent = "Add to cart";
          console.error("Add to cart error:", data.description);
          return;
        }

        const doc = new DOMParser().parseFromString(data.sections["main-cart"], "text/html");

        const newItems = doc.querySelector(".cart-items-container, .mini-cart--empty");
        if (newItems) {
          document.querySelectorAll(".cart-items-container, .mini-cart--empty").forEach(function (el) {
            el.replaceWith(newItems.cloneNode(true));
          });
        }

        [".cart-summary__header", "#cart-total-price", "#checkout", ".cart-summary__free-shipping"].forEach(function (sel) {
          const newEl = doc.querySelector(sel);
          if (!newEl) return;
          document.querySelectorAll(sel).forEach(function (el) {
            el.replaceWith(newEl.cloneNode(true));
          });
        });

        const cartCount = doc.querySelector(".cart-count");
        document.querySelectorAll("#cart-open-block .header__icons--cart-open .cart-count").forEach(function (el) {
          if (cartCount) {
            el.classList.remove("visually-hidden");
            el.textContent = cartCount.textContent;
          } else {
            el.classList.add("visually-hidden");
          }
        });

        document.querySelectorAll(".cart-items-container .icon").forEach(function (icon) {
          icon.classList.add("loaded");
        });
        document.querySelectorAll(".cart-items-container .cart-item").forEach(attachCartItemBehavior);

        button.textContent = "Added to cart";
        setTimeout(function () {
          button.disabled = false;
          button.textContent = "Add to cart";
        }, 1500);
      })
      .catch(function (err) {
        console.error("Add to cart error:", err);
        button.disabled = false;
        button.textContent = "Add to cart";
      });
  }

  function ensureContainer() {
    let container = document.querySelector(".mini-cart-recommendations");
    if (container) return container;

    const itemsContainer = document.querySelector("#mini-cart .cart-items-container");
    if (!itemsContainer || !itemsContainer.parentElement) return null;

    container = document.createElement("div");
    container.className = "mini-cart-recommendations u-hide";
    itemsContainer.parentElement.appendChild(container);
    return container;
  }

  function renderRecommendations(products) {
    const container = ensureContainer();
    if (!container) return;

    if (!products || !products.length) {
      container.innerHTML = "";
      container.classList.add("u-hide");
      return;
    }

    container.classList.remove("u-hide");
    container.innerHTML =
      '<p class="mini-cart-recommendations__title text-sm">Recommended for you</p>' +
      '<div class="mini-cart-recommendations__grid">' +
      products
        .slice(0, 2)
        .map(function (p) {
          return (
            '<div class="mini-cart-recommendations__item">' +
            '<a href="' + p.url + '" class="mini-cart-recommendations__link">' +
            '<figure class="mini-cart-recommendations__image">' +
            '<img src="' + p.featured_image + '" alt="' + p.title + '" width="200" height="200">' +
            '</figure>' +
            '<p class="mini-cart-recommendations__item-title">' + p.title + '</p>' +
            '</a>' +
            '<div class="mini-cart-recommendations__bottom">' +
            '<span class="mini-cart-recommendations__item-price">' + p.price_formatted + '</span>' +
            '<button type="button" class="button button--sm-secondary mini-cart-recommendations__add" data-product-id="' + p.id + '" data-variant-id="' + p.variant_id + '">Add to cart</button>' +
            '</div>' +
            '</div>'
          );
        })
        .join("") +
      "</div>";

    container.querySelectorAll(".mini-cart-recommendations__add").forEach(function (btn) {
      btn.addEventListener("click", function () {
        addToCartFromRecommendation(
          btn.getAttribute("data-product-id"),
          btn.getAttribute("data-variant-id"),
          btn
        );
      });
    });
  }

  function fetchRecommendations(retryCount) {
    retryCount = retryCount || 0;
    if (!window.routes || !window.routes.recommendations) return;

    fetch("/cart.js")
      .then(function (res) {
        return res.json();
      })
      .then(function (cart) {
        if (!cart.items || !cart.items.length) {
          if (retryCount < 2) {
            setTimeout(function () {
              fetchRecommendations(retryCount + 1);
            }, 400);
          }
          return;
        }
        const productId = cart.items[cart.items.length - 1].product_id;

        return fetch(
          window.routes.recommendations + ".json?product_id=" + productId + "&limit=2"
        );
      })
      .then(function (res) {
        return res && res.json();
      })
      .then(function (data) {
        if (!data) return;
        const mapped = (data.products || []).map(function (p) {
          return {
            id: p.id,
            variant_id: p.variants && p.variants[0] ? p.variants[0].id : p.id,
            url: p.url,
            title: p.title,
            featured_image: p.featured_image,
            price_formatted: (p.price / 100).toFixed(2).replace(".", ",") + " €",
          };
        });

        if ((!data.products || !data.products.length) && retryCount < 2) {
          setTimeout(function () {
            fetchRecommendations(retryCount + 1);
          }, 400);
          return;
        }

        renderRecommendations(mapped);
      })
      .catch(function (err) {
        console.error("Cart recommendations error:", err);
      });
  }

  const miniCartContent = document.querySelector("#mini-cart .mini-cart__content");
  if (miniCartContent) {
    const observer = new MutationObserver(function () {
      fetchRecommendations();
    });
    observer.observe(miniCartContent, { childList: true, subtree: false });
  }

  fetchRecommendations();
})();